module.exports = __webpack_public_path__ + "static/03-pen-paper-writing 1-df0298c7c336462862f081c6d0a4de7a.svg";